import { render, staticRenderFns } from "./getCode.vue?vue&type=template&id=47b029d2"
import script from "./getCode.vue?vue&type=script&lang=js"
export * from "./getCode.vue?vue&type=script&lang=js"
import style0 from "./getCode.vue?vue&type=style&index=0&id=47b029d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports